module.exports = __webpack_public_path__ + "img/hkig.b0f9be4b.png";